import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useImperativeHandle, useState } from "react";
import axios from "axios";
import { axiosErrorHandler } from "../../../../../swzutils";
import ValOrDash from "../../../components/ValOrDash";
import { Spin } from "antd";
import ShortfallValueWithIcon from "../ShortfallValueWithIcon";
import HelpLabel from "../../../components/HelpLabel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTruck } from '@fortawesome/free-solid-svg-icons/faTruck';
const DeliveryCapacityWidget = (props, exportedRef) => {
    const [stateLoading, setStateLoading] = useState(false);
    const [stateData, setStateData] = useState(null);
    useImperativeHandle(exportedRef, () => {
        return {
            refresh
        };
    });
    // useEffect(() => {
    //     refresh()
    // }, []);
    const refresh = () => {
        loadDeliveryCapacity();
    };
    const loadDeliveryCapacity = () => {
        setStateLoading(true);
        axios.get(`/admin/v1/dashboard/delivery-capacity/${props.date}`)
            .then(response => {
            setStateData(response.data);
        }).catch(error => {
            setStateData(null);
            axiosErrorHandler(error);
        }).finally(() => {
            setStateLoading(false);
        });
    };
    const { deliveryCapacity, deliveryCapacityShortfall } = stateData ?? {};
    return (_jsx(Spin, { spinning: stateLoading, children: _jsxs("div", { className: "widget", children: [_jsx("div", { className: "widget-icon widget-icon-dk-blue", children: _jsx(FontAwesomeIcon, { icon: faTruck }) }), _jsx("h2", { className: "widget-value", children: _jsx(ValOrDash, { val: deliveryCapacity }) }), _jsx("p", { children: _jsx(HelpLabel, { title: "Planned Delivery capacity", helpText: _jsxs("div", { children: [_jsx("p", { children: "The value is calculated by first determining the time worked by all vehicles including those that have been hired from the marketplace. The time worked is then divided by average time required for the planned deliveries." }), _jsxs("p", { children: [_jsx("strong", { children: "NOTE:" }), " that this value depends on deliveries having been pre-planned in to vehicles."] })] }) }) }), _jsx("div", { className: "widget-separator" }), _jsx("h2", { className: "widget-value", children: _jsx(ShortfallValueWithIcon, { shortfallValue: deliveryCapacityShortfall }) }), _jsx("p", { children: _jsx(HelpLabel, { title: "Planned Delivery capacity shortfall", helpText: _jsxs("div", { children: [_jsx("p", { children: "This shortfall is calculated by subtracting the planned delivery capacity from the total number of deliveries." }), _jsxs("p", { children: [_jsx("strong", { children: "NOTE:" }), " on demand deliveries placed on the marketplace are also excluded from the shortfall."] })] }) }) })] }) }));
};
export default React.forwardRef(DeliveryCapacityWidget);
